import React from 'react';
import { AppList, EmployeeIcon } from '@capcenter/shared';
import HamptonRoadsImg from './LocationsImages/best-mortgage-best-realty-virginia-beach-va-hampton-roads.png';
import CentralVaImg from './LocationsImages/best-mortgage-best-realty-richmond-va-rva.png';
import RaleighImg from './LocationsImages/best-mortgage-best-realty-cary-raleigh-durham-nc.jpg';
import NorthernVaImg from './LocationsImages/best-mortgage-best-realty-mclean-va-northern-virginia-nova.png';
import CharlotteImg from './LocationsImages/best-mortgage-best-realty-charlotte-nc.png';
import CharlestonImg from './LocationsImages/best-mortgage-best-realty-charleston-sc.jpg';
import GreenvilleImg from './LocationsImages/best-mortgage-best-realty-greenville-sc.png';
import ColumbiaMDImg from './LocationsImages/best-mortgage-best-realty-columbia-md.png';
import ColumbiaSCImg from './LocationsImages/best-mortgage-best-realty-columbia-sc.jpg';

//import BackupImg from './LocationsImages/Backup.svg';

const extensions = [
  {
    title: 'Buying, Selling, Refinancing',
    ext: '1',
  },
  {
    title: 'In Process / In Close Loans',
    ext: '2',
  },
  {
    title: 'General Questions',
    ext: '0',
  },
];

const LocationsData = [
  {
    image: <EmployeeIcon team="client-relations" />,
    title: 'Client Relations',
    opens: '8:30',
    closes: '6',
    phoneNumber: '1-800-968-5844',
    extensions: extensions,
    email: AppList?.contactClientRelations,
    call: {url: 'https://outlook.office365.com/owa/calendar/CapCenterClientRelations@capcenter.com/bookings/'}
  },
  {
    image: <img className="img-fluid" src={CentralVaImg} alt="CapCenter's Innsbrook Glen Allen, Virginia (Central Virginia HQ) Office 4461 Cox Road Glen Allen, VA 23060" />,
    title: 'Central Virginia Office (RVA)',
    opens: '8:30',
    closes: '5',
    phoneNumber: '804-968-5000',
    extensions: extensions,
    address: ['4461 Cox Road', 'Glen Allen, VA 23060'],
    lat: 37.65776,
    lng: -77.57469,
    regionId: 'Central Va',
    link: '/contact/best-mortgage-glen-allen-va'
  },
  {
    image: <img className="img-fluid" src={HamptonRoadsImg} alt="CapCenter's Virginia Beach, Virginia (Hampton Roads) Office 277 Bendix Rd #240 Virginia Beach, VA 23452" />,
    title: 'Hampton Roads Office',
    opens: '8:30',
    closes: '5',
    phoneNumber: '757-456-1800',
    extensions: extensions,
    address: ['277 Bendix Rd #240', 'Virginia Beach, VA 23452'],
    lat: 36.83463,
    lng: -76.12609,
    regionId: 'Hampton Roads',
    link: '/contact/best-mortgage-virginia-beach-va'
  },
  {
    image: <img className="img-fluid" src={NorthernVaImg} alt="CapCenter's McLean, Virginia (Northern Virginia) Office 1640 Boro Place McLean VA 22102" />,
    title: 'McLean-Northern Virginia Office (DMV)',
    opens: '8:30',
    closes: '5',
    isByAppointmentOnly: true,
    phoneNumber: '571-669-3559',
    extensions: extensions,
    address: ['1640 Boro Place', 'McLean VA 22102'],
    lat: 38.92209,
    lng: -77.23039,
    regionId: 'Northern Va',
    link: '/contact/best-mortgage-mclean-va'
  },
  {
    image: <img className="img-fluid" src={ColumbiaMDImg} alt="CapCenter's Columbia, Maryland Office 10320 Little Patuxent Pkwy Suite 200 Columbia, MD 21044" />,
    title: 'Columbia-Baltimore Office (DMV)',
    opens: '8:30',
    closes: '5',
    phoneNumber: '410-858-4991',
    extensions: extensions,
    address: ['10320 Little Patuxent Pkwy Suite 200', 'Columbia, MD 21044'],
    lat: 39.21498,
    lng: -76.85827,
    regionId: 'Baltimore',
    isByAppointmentOnly: true,
    link: '/contact/best-mortgage-columbia-md'
  },
  {
    image: <img className="img-fluid" src={RaleighImg} alt="CapCenter's Cary, North Carolina (Raleigh, Durham) Office 2500 Regency Parkway Cary, NC 27518" />,
    title: 'Cary-Raleigh-Durham Office (NC)',
    opens: '8:30',
    closes: '5',
    isByAppointmentOnly: true,
    phoneNumber: '919-636-6166',
    extensions: extensions,
    address: ['2500 Regency Parkway', 'Cary, NC 27518'],
    lat: 35.81526,
    lng: -78.81595,
    regionId: 'Raleigh',
    link: '/contact/best-mortgage-cary-nc'
  },
  {
    image: <img className="img-fluid" src={CharlotteImg} alt="CapCenter's Charlotte, North Carolina Office 15720 Brixham Hill Ave #500 Charlotte, NC 28277" />,
    title: 'Charlotte Office (NC)',
    opens: '8:30',
    closes: '5',
    phoneNumber: '704-821-5599',
    extensions: extensions,
    address: ['15720 Brixham Hill Ave #500', 'Charlotte, NC 28277'],
    lat: 35.05925,
    lng: -80.85214,
    regionId: 'Charlotte',
    isByAppointmentOnly: true,
    link: '/contact/best-mortgage-charlotte-nc'
  },
  {
    image: <img className="img-fluid" src={GreenvilleImg} alt="CapCenter's Greenville, South Carolina Office 355 S Main St, 1st Floor, Greenville, SC 29601" />,
    title: 'Greenville Office (SC)',
    opens: '8:30',
    closes: '5',
    isByAppointmentOnly: true,
    phoneNumber: '864-900-2131',
    extensions: extensions,
    address: ['355 S Main St, 1st Floor', 'Greenville, SC, 29601'],
    lat: 34.85182,
    lng: -82.39885,
    regionId: 'Upstate',
    link: '/contact/best-mortgage-greenville-sc'
  },
  {
    image: <img className="img-fluid" src={CharlestonImg} alt="CapCenter's Charleston, South Carolina Office 170 Meeting Street STE 110, Charleston, SC 29401" />,
    title: 'Charleston Office (SC)',
    opens: '8:30',
    closes: '5',
    phoneNumber: '843-501-2366',
    extensions: extensions,
    address: ['170 Meeting Street STE 110', 'Charleston, SC 29401'],
    lat: 32.7796829,
    lng: -79.9334608,
    regionId: 'Charleston',
    isByAppointmentOnly: true,
    link: '/contact/best-mortgage-charleston-sc'
  },
  {
    image: <img className="img-fluid" src={ColumbiaSCImg} alt="CapCenter's Columbia, South Carolina Office 1320 Main Street, Ste 300, Columbia, SC" />,
    title: 'Columbia Office (SC)',
    opens: '8:30',
    closes: '5',
    phoneNumber: '1-800-968-5844',
    extensions: extensions,
    address: ['1320 Main Street STE 300', 'Columbia, SC 29201'],
    lat: 34.0033255,
    lng: -81.0361193,
    regionId: 'SC-Columbia',
    isByAppointmentOnly: true,
    link: '/contact/best-mortgage-columbia-sc'
  },
];

export default LocationsData;